import {
    CrudResourceContextProvider,
    createCrudResourceContext,
    useCrudResourceContext,
} from './CrudResourceContextProvider'

/**
 * ResourceList - компонент для відображення списку ресурсів
 * 
 * @param {Object} props
 * @param {Object} props.crudContext - готовий контекст CRUD (опціонально)
 * @param {string} props.registryKey - ОБОВ'ЯЗКОВИЙ ключ реєстру (якщо не передано crudContext)
 *   Приклад: "Setting.User.mainList"
 *   Для генерації використовуйте: generateRegistryKey.list('Setting.User', 'mainList')
 * 
 * ВАЖЛИВО: параметр useRegistry видалено - всі контексти зберігаються в registry
 */
export const ResourceList = ({ crudContext = undefined, registryKey, ...props }) => {
    // Валідація: якщо немає готового контексту - registryKey обов'язковий
    if (!crudContext && !registryKey) {
        throw new Error(
            '[ResourceList] Параметр "registryKey" є обов\'язковим.\n' +
            'Приклад: registryKey="Setting.User.mainList"\n' +
            'Для генерації використовуйте: generateRegistryKey.list("Setting.User", "mainList") з @/Core/Utils/generateRegistryKey'
        )
    }

    if (!crudContext)
        crudContext = createCrudResourceContext({
            contextType: 'list',
            accessMode: 'read_collection',
            registryKey, // Передаємо обов'язковий ключ
            ...props
        })
    else
        crudContext.mergeProps({
            contextType: 'list',
            accessMode: 'read_collection',
            ...props
        })
    
    const parentCrudContext = useCrudResourceContext()
    if (parentCrudContext) crudContext.setParentCrudContext(parentCrudContext)

    return <CrudResourceContextProvider value={crudContext}>{crudContext.render()}</CrudResourceContextProvider>
}
